import React, { useState, useEffect, useMemo } from 'react';
import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    signInAnonymously, 
    onAuthStateChanged 
} from 'firebase/auth';
import { 
    getFirestore, 
    collection, 
    addDoc, 
    onSnapshot,
    doc,
    updateDoc,
    writeBatch,
    setDoc,
    getDoc,
    query,
    where,
    getDocs
} from 'firebase/firestore';

// --- Íconos SVG para una mejor interfaz ---
const PlusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>;
const TableIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>;
const CheckCircleIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z" /></svg>;
const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
const SearchIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>;
const BillIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const CopyIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>;
const SendIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" /></svg>;
const ReportsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const DownloadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>;
const AlertIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-yellow-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>;

// --- Configuración de Firebase (se inyectará en el entorno de ejecución) ---
const firebaseConfig = {
  apiKey: "AIzaSyA7cehZ__Be0QmPHoDFGyao7qSKOesQZsA",
  authDomain: "app-casmat.firebaseapp.com",
  projectId: "app-casmat",
  storageBucket: "app-casmat.firebasestorage.app",
  messagingSenderId: "960579013899",
  appId: "1:960579013899:web:07e95dfd17e4e21350660e"
};

const appId = firebaseConfig.appId;

// --- Inicialización de Firebase ---
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// --- Componente para un Modal genérico ---
const Modal = ({ children, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="p-6 relative">
                {onClose && <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
                    <CloseIcon />
                </button>}
                {children}
            </div>
        </div>
    </div>
);

// --- Componente para editar gastos y suma asegurada ---
const EditExpenseModal = ({ claim, userId, onClose }) => {
    const [newExpenseAmount, setNewExpenseAmount] = useState('');
    const [newExpenseDescription, setNewExpenseDescription] = useState('');
    const [newExpenseObservations, setNewExpenseObservations] = useState('');
    const [newInsuredAmount, setNewInsuredAmount] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    
    const formatCurrency = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const parsedExpense = parseFloat(newExpenseAmount);
        const parsedInsured = parseFloat(newInsuredAmount);

        if (!newExpenseAmount && !newInsuredAmount) {
            alert("No hay cambios para guardar. Ingrese un nuevo gasto o una nueva suma asegurada.");
            return;
        }

        setIsSaving(true);
        const claimRef = doc(db, 'artifacts', appId, 'users', userId, 'claims', claim.id);
        
        const dataToUpdate = {};

        if (!isNaN(parsedExpense) && parsedExpense > 0) {
            const newExpense = { amount: parsedExpense, description: newExpenseDescription || "Gasto adicional", observations: newExpenseObservations, date: new Date() };
            const currentExpenses = Array.isArray(claim.expenses) ? claim.expenses : [];
            dataToUpdate.expenses = [...currentExpenses, newExpense];
            dataToUpdate.totalExpenses = (claim.totalExpenses || 0) + parsedExpense;
        }

        if (newInsuredAmount !== '' && !isNaN(parsedInsured)) {
            dataToUpdate.insuredAmount = parsedInsured;
        }

        try {
            if (Object.keys(dataToUpdate).length > 0) {
                await updateDoc(claimRef, dataToUpdate);
            }
            onClose();
        } catch (error) {
            console.error("Error al actualizar el siniestro: ", error);
            alert("Hubo un error al guardar los cambios.");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal onClose={onClose}>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Editar Gasto y Suma Asegurada</h2>
            <div className="mb-6 space-y-2 text-gray-600">
                <p>Reporte: <span className="font-semibold text-gray-800">{claim.reportNumber}</span></p>
                <p>Paciente: <span className="font-semibold text-gray-800">{`${claim.firstName} ${claim.paternalLastName}`}</span></p>
                <p>Gasto Total Actual: <span className="font-semibold text-blue-600">{formatCurrency(claim.totalExpenses)}</span></p>
                <p>Suma Asegurada Actual: <span className="font-semibold text-blue-600">{formatCurrency(claim.insuredAmount)}</span></p>
            </div>
            
            <form onSubmit={handleSubmit}>
                <div className="space-y-6">
                    <fieldset className="border border-gray-300 p-4 rounded-lg"><legend className="px-2 text-lg font-semibold text-gray-700">Añadir Nuevo Gasto</legend>
                         <div className="space-y-4 mt-2">
                            <input type="text" placeholder="Descripción del nuevo gasto" value={newExpenseDescription} onChange={(e) => setNewExpenseDescription(e.target.value)} className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                            <input type="number" placeholder="Monto del nuevo gasto (se sumará)" value={newExpenseAmount} onChange={(e) => setNewExpenseAmount(e.target.value)} className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                             <textarea placeholder="Observaciones (opcional)" value={newExpenseObservations} onChange={(e) => setNewExpenseObservations(e.target.value)} className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" rows="2"></textarea>
                        </div>
                    </fieldset>
                    <fieldset className="border border-gray-300 p-4 rounded-lg"><legend className="px-2 text-lg font-semibold text-gray-700">Editar Suma Asegurada</legend>
                        <input type="number" placeholder="Nuevo monto (reemplazará el actual)" value={newInsuredAmount} onChange={(e) => setNewInsuredAmount(e.target.value)} className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"/>
                    </fieldset>
                </div>
                <div className="mt-8 flex justify-end space-x-3">
                    <button type="button" onClick={onClose} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors">Cancelar</button>
                    <button type="submit" disabled={isSaving} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:bg-blue-300">
                        {isSaving ? 'Guardando...' : 'Guardar Cambios'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

// --- Componente para el modal de Facturación ---
const BillingModal = ({ claim, userId, nextFolio, onFolioUpdate, onClose }) => {
    const [copyButtonText, setCopyButtonText] = useState('Copiar Datos');
    const [isSaving, setIsSaving] = useState(false);
    const [invoiceFolio, setInvoiceFolio] = useState('');

    useEffect(() => {
        if (claim.billingData?.folio) {
            setInvoiceFolio(claim.billingData.folio);
        } else if (nextFolio) {
            setInvoiceFolio(nextFolio);
        }
    }, [nextFolio, claim]);

    const getInvoiceAmount = (claimType) => {
        switch (claimType) {
            case 'AU1': return 1000;
            case 'AU2': return 500;
            case 'ES': return 200;
            case 'RCGE': case 'SEMP': return 550;
            default: return 0;
        }
    };
    const invoiceAmount = getInvoiceAmount(claim.claimType);

    const handleCopy = () => {
        const maternalName = claim.maternalLastName ? ` ${claim.maternalLastName}` : '';
        const textToCopy = `caso: ${claim.firstName} ${claim.paternalLastName}${maternalName}, Póliza: ${claim.policyNumber}, Reporte o Siniestro: ${claim.reportNumber}`;
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            setCopyButtonText('¡Copiado!');
        } catch (err) {
            console.error('Error al copiar texto: ', err);
            setCopyButtonText('Error al copiar');
        }
        document.body.removeChild(textArea);
        setTimeout(() => setCopyButtonText('Copiar Datos'), 2000);
    };
    
    const handleSaveBilling = async () => {
        if (!invoiceFolio) {
            alert("Por favor, ingrese un folio de factura.");
            return;
        }
        setIsSaving(true);
        const folioToSave = Number(invoiceFolio);

        try {
            const claimRef = doc(db, 'artifacts', appId, 'users', userId, 'claims', claim.id);
            const billingData = {
                folio: folioToSave,
                amount: invoiceAmount,
                date: new Date(),
            };
            await updateDoc(claimRef, { billingData, status: 'Cerrado', paymentStatus: 'pending' });
            onFolioUpdate(folioToSave);
            onClose();
        } catch (error) {
            console.error("Error al guardar la facturación:", error);
            alert("No se pudo guardar la información de facturación.");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal onClose={onClose}>
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Información para Facturación</h2>
            <div className="space-y-6">
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                    <div className="bg-gray-50 p-3 rounded-lg"><p className="font-semibold text-gray-500"># Reporte / Siniestro</p><p className="text-gray-800">{claim.reportNumber}</p></div>
                    <div className="bg-gray-50 p-3 rounded-lg"><p className="font-semibold text-gray-500"># Póliza</p><p className="text-gray-800">{claim.policyNumber}</p></div>
                    <div className="bg-gray-50 p-3 rounded-lg col-span-1 md:col-span-2"><p className="font-semibold text-gray-500">Paciente</p><p className="text-gray-800">{`${claim.firstName} ${claim.paternalLastName} ${claim.maternalLastName || ''}`}</p></div>
                </div>
                <button onClick={handleCopy} className="w-full flex items-center justify-center p-3 bg-gray-200 text-gray-700 font-bold rounded-lg hover:bg-gray-300 transition-all duration-300"><CopyIcon /> {copyButtonText}</button>
                <fieldset className="border border-gray-300 p-4 rounded-lg"><legend className="px-2 text-lg font-semibold text-gray-700">Datos de Factura</legend>
                    <div className="space-y-4 mt-2">
                         <FormField id="claimTypeInfo" label="Tipo de siniestro"><input id="claimTypeInfo" type="text" readOnly value={claim.claimType} className="w-full p-3 bg-gray-200 text-gray-500 rounded-lg cursor-not-allowed"/></FormField>
                         <FormField id="invoiceFolio" label="Folio de la factura" required><input id="invoiceFolio" type="number" value={invoiceFolio} onChange={(e) => setInvoiceFolio(e.target.value)} className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                         <FormField id="invoiceAmount" label="Monto de la factura"><input id="invoiceAmount" type="text" readOnly value={new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(invoiceAmount)} className="w-full p-3 bg-gray-200 text-gray-500 rounded-lg cursor-not-allowed" /></FormField>
                    </div>
                </fieldset>
            </div>
            <div className="mt-8 flex justify-end space-x-3">
                <button type="button" onClick={onClose} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors">Cancelar</button>
                <button onClick={handleSaveBilling} disabled={isSaving || !!claim.billingData} className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:bg-green-300 disabled:cursor-not-allowed">
                    {isSaving ? 'Guardando...' : (claim.billingData ? 'Facturado' : 'Guardar Factura')}
                </button>
            </div>
        </Modal>
    );
};

// --- Componente de ayuda para campos de formulario ---
const FormField = ({ id, label, required, children }) => (
    <div><label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">{label} {required && <span className="text-red-500">*</span>}</label>{children}</div>
);

// --- Componente para el formulario de nuevo siniestro ---
const NewCaseForm = ({ userId, claims }) => {
    const [formData, setFormData] = useState({ reportNumber: '', firstName: '', paternalLastName: '', maternalLastName: '', policyNumber: '', hospital: '', initialExpense: '', insuredAmount: '', claimType: '', folioHospital: '' });
    const [isSaving, setIsSaving] = useState(false);
    const [upgradeModal, setUpgradeModal] = useState({ isOpen: false, existingClaim: null });
    const [au1ConflictModal, setAu1ConflictModal] = useState({ isOpen: false, existingClaim: null });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    
    const resetForm = () => {
        setFormData({ reportNumber: '', firstName: '', paternalLastName: '', maternalLastName: '', policyNumber: '', hospital: '', initialExpense: '', insuredAmount: '', claimType: '', folioHospital: '' });
    };

    const performSave = async (dataToSave, claimToUpdate = null) => {
        setIsSaving(true);
        try {
            const claimsCollection = collection(db, 'artifacts', appId, 'users', userId, 'claims');
            const batch = writeBatch(db);

            const newClaimRef = doc(claimsCollection);
            const finalData = {
                ...dataToSave,
                insuredAmount: parseFloat(dataToSave.insuredAmount) || 0,
                expenses: dataToSave.initialExpense ? [{ amount: parseFloat(dataToSave.initialExpense), description: "Gasto inicial de apertura", date: new Date(), observations: '' }] : [],
                totalExpenses: parseFloat(dataToSave.initialExpense) || 0,
                status: 'Abierto',
                createdAt: new Date(),
            };
            batch.set(newClaimRef, finalData);

            if (claimToUpdate) {
                const existingClaimRef = doc(db, 'artifacts', appId, 'users', userId, 'claims', claimToUpdate.id);
                batch.update(existingClaimRef, claimToUpdate.data);
            }

            await batch.commit();
            resetForm();
            alert("Siniestro registrado exitosamente.");
        } catch (error) {
            console.error("Error al registrar siniestro: ", error);
            alert("Ocurrió un error al guardar el caso.");
        } finally {
            setIsSaving(false);
            setUpgradeModal({ isOpen: false, existingClaim: null });
            setAu1ConflictModal({ isOpen: false, existingClaim: null });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!userId) {
            alert("No se pudo obtener el ID de usuario. Por favor, recargue la página.");
            return;
        }

        const { reportNumber, claimType } = formData;
        
        const existingClaimsWithSameReportNumber = claims.filter(c => c.reportNumber === reportNumber);
        const existingAU1 = existingClaimsWithSameReportNumber.find(c => c.claimType === 'AU1');

        if (claimType === 'AU1' && existingAU1) {
            setAu1ConflictModal({ isOpen: true, existingClaim: existingAU1 });
            return;
        }

        if (claimType === 'AU2' && existingAU1) {
            setUpgradeModal({ isOpen: true, existingClaim: existingAU1 });
            return;
        }
        
        performSave(formData);
    };

    return (
        <>
            {upgradeModal.isOpen && (
                <Modal>
                    <div className="text-center">
                        <AlertIcon/>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Confirmación Requerida</h3>
                        <p className="text-gray-600 mb-6">
                            Ya existe un siniestro con este número de reporte pero con tipo AU1.
                            <br/>
                            ¿Desea cambiar el tipo del siniestro original a AU2?
                        </p>
                        <div className="flex justify-center space-x-4">
                            <button onClick={() => performSave(formData, { id: upgradeModal.existingClaim.id, data: { claimType: 'AU2' } })} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Sí, cambiar y guardar</button>
                            <button onClick={() => performSave(formData)} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">No, solo guardar nuevo</button>
                        </div>
                    </div>
                </Modal>
            )}
            {au1ConflictModal.isOpen && (
                 <Modal>
                    <div className="text-center">
                        <AlertIcon/>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Conflicto de Siniestro AU1</h3>
                        <p className="text-gray-600 mb-6">
                            No se puede registrar otro siniestro de tipo AU1 con este número de reporte.
                            <br/>
                            ¿Desea guardar este nuevo caso como AU2 y actualizar también el caso original a AU2?
                        </p>
                        <div className="flex justify-center space-x-4">
                            <button 
                                onClick={() => {
                                    const newData = { ...formData, claimType: 'AU2' };
                                    performSave(newData, { id: au1ConflictModal.existingClaim.id, data: { claimType: 'AU2' } });
                                }} 
                                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                            >
                                Sí, guardar y actualizar
                            </button>
                            <button 
                                onClick={() => setAu1ConflictModal({ isOpen: false, existingClaim: null })} 
                                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
                <h2 className="text-3xl font-bold text-gray-800 mb-6">Registrar Nuevo Siniestro</h2>
                <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
                    <FormField id="reportNumber" label="# Reporte o Siniestro" required><input id="reportNumber" required name="reportNumber" value={formData.reportNumber} onChange={handleChange} placeholder="Ej: 12345-ABC" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <FormField id="policyNumber" label="# Póliza" required><input id="policyNumber" required name="policyNumber" value={formData.policyNumber} onChange={handleChange} placeholder="Ej: 987654321" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <FormField id="claimType" label="Tipo de siniestro" required><select id="claimType" required name="claimType" value={formData.claimType} onChange={handleChange} className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"><option value="" disabled>Seleccione una opción</option><option value="AU1">AU1</option> <option value="AU2">AU2</option> <option value="ES">ES</option><option value="RCGE">RCGE</option> <option value="SEMP">SEMP</option></select></FormField>
                    <FormField id="hospital" label="Hospital que atiende" required><input id="hospital" required name="hospital" value={formData.hospital} onChange={handleChange} placeholder="Ej: Hospital Ángeles" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <FormField id="firstName" label="Nombre(s)" required><input id="firstName" required name="firstName" value={formData.firstName} onChange={handleChange} placeholder="Juan" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <FormField id="paternalLastName" label="Apellido Paterno" required><input id="paternalLastName" required name="paternalLastName" value={formData.paternalLastName} onChange={handleChange} placeholder="Pérez" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <FormField id="maternalLastName" label="Apellido Materno"><input id="maternalLastName" name="maternalLastName" value={formData.maternalLastName} onChange={handleChange} placeholder="García (Opcional)" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <FormField id="folioHospital" label="Folio Hospital"><input id="folioHospital" name="folioHospital" value={formData.folioHospital} onChange={handleChange} placeholder="Folio del hospital (Opcional)" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
                        <FormField id="initialExpense" label="Monto del gasto inicial"><input id="initialExpense" type="number" name="initialExpense" value={formData.initialExpense} onChange={handleChange} placeholder="0.00" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                        <FormField id="insuredAmount" label="Suma asegurada"><input id="insuredAmount" type="number" name="insuredAmount" value={formData.insuredAmount} onChange={handleChange} placeholder="0.00" className="w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" /></FormField>
                    </div>
                    <button type="submit" disabled={isSaving} className="md:col-span-2 w-full mt-4 p-4 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-all duration-300 disabled:bg-blue-300">{isSaving ? 'Guardando...' : 'Registrar Caso'}</button>
                </form>
            </div>
        </>
    );
};

// --- Componente para la vista de Panel de Siniestros ---
const DashboardView = ({ claims, onEditExpense }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const formatCurrency = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0);

    const filteredClaims = useMemo(() => {
        const activeClaims = claims.filter(c => c.status === 'Abierto');
        if (!searchTerm) return activeClaims;
        const term = searchTerm.toLowerCase();
        return activeClaims.filter(claim => claim.reportNumber.toLowerCase().includes(term) || claim.firstName.toLowerCase().includes(term) || claim.paternalLastName.toLowerCase().includes(term) || (claim.maternalLastName && claim.maternalLastName.toLowerCase().includes(term)));
    }, [claims, searchTerm]);

    return (
        <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <h2 className="text-3xl font-bold text-gray-800">Panel de Siniestros Activos</h2>
                <div className="relative w-full md:w-auto">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3"><SearchIcon /></span>
                    <input type="text" placeholder="Buscar por #, nombre..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full md:w-80 p-3 pl-10 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="border-b-2 border-gray-200">
                        <tr>
                            <th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap"># Reporte / Siniestro</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Tipo</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Nombre(s)</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Apellido Paterno</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Apellido Materno</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Hospital</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Gasto Total</th><th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Suma Asegurada</th><th className="p-3 text-sm font-semibold text-gray-500 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredClaims.map(claim => (
                            <tr key={claim.id} className="border-b border-gray-100 hover:bg-gray-50">
                                <td className="p-3 font-medium text-gray-800">{claim.reportNumber}</td><td className="p-3 text-gray-700 font-medium">{claim.claimType}</td><td className="p-3 text-gray-700">{claim.firstName}</td><td className="p-3 text-gray-700">{claim.paternalLastName}</td><td className="p-3 text-gray-700">{claim.maternalLastName || ''}</td><td className="p-3 text-gray-700">{claim.hospital}</td><td className="p-3 text-gray-700 font-semibold">{formatCurrency(claim.totalExpenses)}</td><td className="p-3 text-gray-700">{formatCurrency(claim.insuredAmount)}</td><td className="p-3 text-center"><button onClick={() => onEditExpense(claim)} className="bg-blue-100 text-blue-700 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-200 transition-colors flex items-center justify-center mx-auto"><EditIcon /> Editar Gasto</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
             {filteredClaims.length === 0 && (<p className="text-center text-gray-500 py-8">{searchTerm ? `No se encontraron siniestros con el término "${searchTerm}".` : "No hay siniestros abiertos por el momento."}</p>)}
        </div>
    );
};

// --- Componente para la vista de Control de Facturación ---
const BillingControlView = ({ claims, userId, onBilling }) => {
    const [selectedClaims, setSelectedClaims] = useState(new Set());
    const [isUpdating, setIsUpdating] = useState(false);

    const formatCurrency = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0);
    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp.seconds * 1000).toLocaleDateString('es-MX');
    };

    const handleSelectClaim = (claimId) => {
        setSelectedClaims(prev => {
            const newSelection = new Set(prev);
            if (newSelection.has(claimId)) {
                newSelection.delete(claimId);
            } else {
                newSelection.add(claimId);
            }
            return newSelection;
        });
    };
    
    const handleMarkAsSent = async () => {
        if (selectedClaims.size === 0) return;
        setIsUpdating(true);
        try {
            const batch = writeBatch(db);
            selectedClaims.forEach(claimId => {
                const claimData = claims.find(c => c.id === claimId);
                if(claimData && claimData.billingData && claimData.paymentStatus !== 'sent') {
                   const claimRef = doc(db, 'artifacts', appId, 'users', userId, 'claims', claimId);
                   batch.update(claimRef, { paymentStatus: 'sent', sentToPaymentDate: new Date() });
                }
            });
            await batch.commit();
            setSelectedClaims(new Set());
        } catch (error) {
            console.error("Error al marcar como enviado a pago: ", error);
            alert("Ocurrió un error al actualizar los casos.");
        } finally {
            setIsUpdating(false);
        }
    };

    const getBillingStatusChip = (claim) => {
        if (claim.paymentStatus === 'sent') {
            return <span className="px-3 py-1 text-xs font-semibold text-purple-800 bg-purple-100 rounded-full">Enviado a Pago</span>;
        }
        if (claim.billingData?.folio) {
            return <span className="px-3 py-1 text-xs font-semibold text-green-800 bg-green-100 rounded-full">Facturado</span>;
        }
        return <span className="px-3 py-1 text-xs font-semibold text-orange-800 bg-orange-100 rounded-full">No facturado</span>;
    };

    return (
        <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                 <h2 className="text-3xl font-bold text-gray-800">Control de Facturación</h2>
                 <button onClick={handleMarkAsSent} disabled={selectedClaims.size === 0 || isUpdating} className="flex items-center justify-center px-4 py-2 bg-purple-600 text-white font-bold rounded-lg hover:bg-purple-700 transition-colors disabled:bg-purple-300 disabled:cursor-not-allowed">
                     <SendIcon /> {isUpdating ? 'Actualizando...' : `Marcar (${selectedClaims.size}) como Enviados a Pago`}
                 </button>
            </div>
             <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="border-b-2 border-gray-200">
                        <tr>
                            <th className="p-3"><input type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" disabled/></th>
                            <th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap"># Reporte / Siniestro</th>
                            <th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Paciente</th>
                            <th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Folio Factura</th>
                            <th className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">Fecha Envío a Pago</th>
                            <th className="p-3 text-sm font-semibold text-gray-500 text-center">Estado</th>
                            <th className="p-3 text-sm font-semibold text-gray-500 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {claims.map(claim => {
                            const isSelected = selectedClaims.has(claim.id);
                            const canBeSelected = claim.billingData && claim.paymentStatus !== 'sent';
                            return (
                                <tr key={claim.id} className={`border-b border-gray-100 ${isSelected ? 'bg-blue-50' : 'hover:bg-gray-50'}`}>
                                    <td className="p-3"><input type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:bg-gray-200" checked={isSelected} onChange={() => handleSelectClaim(claim.id)} disabled={!canBeSelected}/></td>
                                    <td className="p-3 font-medium text-gray-800">{claim.reportNumber}</td>
                                    <td className="p-3 text-gray-700">{`${claim.firstName} ${claim.paternalLastName} ${claim.maternalLastName || ''}`}</td>
                                    <td className="p-3 font-semibold text-gray-700">{claim.billingData?.folio || 'N/A'}</td>
                                    <td className="p-3 text-gray-700">{formatDate(claim.sentToPaymentDate)}</td>
                                    <td className="p-3 text-center">{getBillingStatusChip(claim)}</td>
                                    <td className="p-3 text-center"><button onClick={() => onBilling(claim)} className="bg-green-100 text-green-700 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-green-200 transition-colors flex items-center justify-center mx-auto"><BillIcon /> {claim.billingData ? 'Ver Factura' : 'Facturar'}</button></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
             </div>
             {claims.length === 0 && (<p className="text-center text-gray-500 py-8">No hay siniestros registrados.</p>)}
        </div>
    );
};

// --- Componente para la vista de Reportes ---
const ReportsView = ({ claims }) => {
    const [reportType, setReportType] = useState('operational');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const formatCurrency = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0);

    const filteredReportData = useMemo(() => {
        let filteredClaims = claims.filter(claim => claim.paymentStatus === 'sent' && claim.sentToPaymentDate);

        if (startDate) {
            const start = new Date(startDate.replace(/-/g, '/'));
            start.setHours(0, 0, 0, 0);
            filteredClaims = filteredClaims.filter(claim => claim.sentToPaymentDate.toDate() >= start);
        }
        if (endDate) {
            const end = new Date(endDate.replace(/-/g, '/'));
            end.setHours(23, 59, 59, 999);
            filteredClaims = filteredClaims.filter(claim => claim.sentToPaymentDate.toDate() <= end);
        }
        
        const reportRows = [];
        filteredClaims.forEach(claim => {
            if (Array.isArray(claim.expenses)) {
                claim.expenses.forEach((expense, index) => {
                    reportRows.push({
                        key: `${claim.id}-${index}`,
                        claim,
                        expense
                    });
                });
            }
        });
        return reportRows;
    }, [claims, startDate, endDate]);


    const handleDownload = (reportData, reportName, headers) => {
        const escapeCsvCell = (cell) => {
            let strCell = String(cell === null || cell === undefined ? '' : cell);
            if (strCell.search(/("|,|\n)/g) >= 0) {
                strCell = `"${strCell.replace(/"/g, '""')}"`;
            }
            return strCell;
        };

        const csvRows = [headers.join(',')];
        
        reportData.forEach(({claim, expense}) => {
             const rowData = [
                escapeCsvCell(claim.folioHospital || 'N/A'),
                escapeCsvCell(expense.amount),
                escapeCsvCell(claim.hospital),
                escapeCsvCell(claim.firstName),
                escapeCsvCell(claim.paternalLastName),
                escapeCsvCell(claim.maternalLastName || ''),
                escapeCsvCell(claim.reportNumber),
                escapeCsvCell(expense.observations || 'N/A'),
                escapeCsvCell(claim.billingData?.folio || 'N/A'),
                escapeCsvCell(claim.billingData?.amount || 'N/A'),
            ];
            // Adjust row data based on report type
            if (reportName.includes('operativo')) {
                 csvRows.push(rowData.slice(0, 8).join(","));
            } else {
                 csvRows.push(rowData.join(","));
            }
        });

        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `${reportName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const operationalHeaders = ["Folio Hospital", "Gasto Individual", "Hospital que atiende", "Nombre(s)", "Apellido Paterno", "Apellido Materno", "# Reporte o Siniestro", "Observaciones"];
    const billingHeaders = [...operationalHeaders, "Folio Factura", "Monto Factura"];

    return (
        <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <h2 className="text-3xl font-bold text-gray-800">Reportes</h2>
                <select value={reportType} onChange={(e) => setReportType(e.target.value)} className="w-full md:w-auto p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="operational">Reporte Operativo</option>
                    <option value="billing">Reporte de Facturación</option>
                </select>
            </div>

            {reportType === 'billing' && (
                <div>
                     <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4 border-b pb-4">
                         <h3 className="text-2xl font-semibold text-gray-700">Reporte de Facturación</h3>
                         <div className="flex flex-col md:flex-row gap-4 items-center">
                            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="p-2 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="p-2 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <button onClick={() => handleDownload(filteredReportData, 'reporte_facturacion', billingHeaders)} className="flex items-center justify-center px-4 py-2 bg-green-600 text-white font-bold rounded-lg hover:bg-green-700 transition-colors">
                                <DownloadIcon /> Descargar CSV
                            </button>
                         </div>
                    </div>
                     <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="border-b-2 border-gray-200">
                                <tr>
                                    {billingHeaders.map(header => <th key={header} className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">{header}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredReportData.map(({key, claim, expense}) => (
                                    <tr key={key} className="border-b border-gray-100 hover:bg-gray-50">
                                        <td className="p-3 text-gray-700">{claim.folioHospital || 'N/A'}</td>
                                        <td className="p-3 text-gray-700 font-semibold">{formatCurrency(expense.amount)}</td>
                                        <td className="p-3 text-gray-700">{claim.hospital}</td>
                                        <td className="p-3 text-gray-700">{claim.firstName}</td>
                                        <td className="p-3 text-gray-700">{claim.paternalLastName}</td>
                                        <td className="p-3 text-gray-700">{claim.maternalLastName || ''}</td>
                                        <td className="p-3 font-medium text-gray-800">{claim.reportNumber}</td>
                                        <td className="p-3 text-gray-700">{expense.observations || 'N/A'}</td>
                                        <td className="p-3 text-gray-700 font-semibold">{claim.billingData?.folio || 'N/A'}</td>
                                        <td className="p-3 text-gray-700 font-semibold">{formatCurrency(claim.billingData?.amount)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {filteredReportData.length === 0 && (<p className="text-center text-gray-500 py-8">No hay casos que coincidan con los filtros seleccionados.</p>)}
                </div>
            )}

            {reportType === 'operational' && (
                <div>
                    <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4 border-b pb-4">
                         <h3 className="text-2xl font-semibold text-gray-700">Reporte Operativo</h3>
                         <div className="flex flex-col md:flex-row gap-4 items-center">
                            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="p-2 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="p-2 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <button onClick={() => handleDownload(filteredReportData, 'reporte_operativo', operationalHeaders)} className="flex items-center justify-center px-4 py-2 bg-green-600 text-white font-bold rounded-lg hover:bg-green-700 transition-colors">
                                <DownloadIcon /> Descargar CSV
                            </button>
                         </div>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="border-b-2 border-gray-200">
                                <tr>
                                    {operationalHeaders.map(header => <th key={header} className="p-3 text-sm font-semibold text-gray-500 whitespace-nowrap">{header}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredReportData.map(({key, claim, expense}) => (
                                    <tr key={key} className="border-b border-gray-100 hover:bg-gray-50">
                                        <td className="p-3 text-gray-700">{claim.folioHospital || 'N/A'}</td>
                                        <td className="p-3 text-gray-700 font-semibold">{formatCurrency(expense.amount)}</td>
                                        <td className="p-3 text-gray-700">{claim.hospital}</td>
                                        <td className="p-3 text-gray-700">{claim.firstName}</td>
                                        <td className="p-3 text-gray-700">{claim.paternalLastName}</td>
                                        <td className="p-3 text-gray-700">{claim.maternalLastName || ''}</td>
                                        <td className="p-3 font-medium text-gray-800">{claim.reportNumber}</td>
                                        <td className="p-3 text-gray-700">{expense.observations || 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {filteredReportData.length === 0 && (<p className="text-center text-gray-500 py-8">No hay casos que coincidan con los filtros seleccionados.</p>)}
                </div>
            )}
        </div>
    );
};

// --- Componente principal de la aplicación ---
export default function App() {
    const [userId, setUserId] = useState(null);
    const [isAuthReady, setIsAuthReady] = useState(false);
    const [view, setView] = useState('dashboard'); // 'new', 'dashboard', 'control', 'reports'
    const [claims, setClaims] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [modal, setModal] = useState({ isOpen: false, type: null, data: null });
    const [nextFolio, setNextFolio] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) { setUserId(user.uid); } 
            else { try { const { user: anonUser } = await signInAnonymously(auth); setUserId(anonUser.uid); } catch(error) { console.error("Error signing in anonymously", error); } }
            setIsAuthReady(true);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (!isAuthReady || !userId) return;
        setIsLoading(true);
        const q = query(collection(db, 'artifacts', appId, 'users', userId, 'claims'));
        const unsubscribeClaims = onSnapshot(q, (querySnapshot) => {
            const claimsData = [];
            querySnapshot.forEach((doc) => claimsData.push({ id: doc.id, ...doc.data() }));
            claimsData.sort((a, b) => {
                const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(0);
                const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(0);
                return dateB - dateA;
            });
            setClaims(claimsData);
            setIsLoading(false);
        }, (error) => { console.error("Error al obtener siniestros:", error); setIsLoading(false); });

        const counterRef = doc(db, 'artifacts', appId, 'users', userId, 'counters', 'invoiceFolio');
        const unsubscribeCounter = onSnapshot(counterRef, async (docSnap) => {
            if (docSnap.exists()) { setNextFolio(docSnap.data().nextFolio); } 
            else { await setDoc(counterRef, { nextFolio: 4101 }); setNextFolio(4101); }
        });
        return () => { unsubscribeClaims(); unsubscribeCounter(); };
    }, [isAuthReady, userId]);
    
    const handleFolioUpdate = async (lastUsedFolio) => {
        const newNextFolio = Math.max(nextFolio, lastUsedFolio + 1);
        const counterRef = doc(db, 'artifacts', appId, 'users', userId, 'counters', 'invoiceFolio');
        await setDoc(counterRef, { nextFolio: newNextFolio });
    };

    const handleEditExpense = (claim) => setModal({ isOpen: true, type: 'editExpense', data: claim });
    const handleBilling = (claim) => setModal({ isOpen: true, type: 'billing', data: claim });
    const handleCloseModal = () => setModal({ isOpen: false, type: null, data: null });
    
    const displayUserId = useMemo(() => { if (!userId) return "Cargando..."; return `ID de Usuario: ${userId}`; }, [userId]);

    const NavButton = ({ activeView, targetView, children, setView }) => {
        const isActive = activeView === targetView;
        return (<button onClick={() => setView(targetView)} className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-300 ${isActive ? 'bg-blue-600 text-white shadow-md' : 'text-gray-600 hover:bg-gray-200'}`}>{children}</button>);
    };

    if (!isAuthReady || isLoading) {
        return (<div className="flex items-center justify-center min-h-screen bg-gray-100"><div className="text-center"><p className="text-xl font-semibold text-gray-700">Cargando aplicación de siniestros...</p><div className="mt-4 w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div></div></div>);
    }
    
    return (
        <div className="bg-gray-50 min-h-screen font-sans">
            {modal.isOpen && modal.type === 'editExpense' && <EditExpenseModal claim={modal.data} userId={userId} onClose={handleCloseModal} />}
            {modal.isOpen && modal.type === 'billing' && <BillingModal claim={modal.data} userId={userId} nextFolio={nextFolio} onFolioUpdate={handleFolioUpdate} onClose={handleCloseModal} />}
            <header className="bg-white shadow-sm p-4 sticky top-0 z-40">
                <div className="container mx-auto flex justify-between items-center">
                    <h1 className="text-2xl font-bold text-blue-700">Control de Siniestros</h1>
                     <div className="hidden md:block bg-gray-100 text-gray-600 text-xs px-3 py-1 rounded-full">{displayUserId}</div>
                </div>
            </header>
            <main className="container mx-auto p-4 md:p-8">
                <div className="bg-white p-3 rounded-xl shadow-md mb-8 flex flex-wrap justify-center items-center gap-4">
                     <NavButton activeView={view} targetView="dashboard" setView={setView}><TableIcon/> <span>Panel Principal</span></NavButton>
                    <NavButton activeView={view} targetView="new" setView={setView}><PlusIcon/> <span>Nuevo Siniestro</span></NavButton>
                    <NavButton activeView={view} targetView="control" setView={setView}><CheckCircleIcon/> <span>Control de Facturación</span></NavButton>
                    <NavButton activeView={view} targetView="reports" setView={setView}><ReportsIcon/> <span>Reportes</span></NavButton>
                </div>
                <div>
                    {view === 'new' && userId && <NewCaseForm userId={userId} claims={claims} />}
                    {view === 'dashboard' && <DashboardView claims={claims} onEditExpense={handleEditExpense} />}
                    {view === 'control' && <BillingControlView claims={claims} userId={userId} onBilling={handleBilling} />}
                    {view === 'reports' && <ReportsView claims={claims} />}
                </div>
            </main>
             <footer className="text-center py-4">
                <p className="text-sm text-gray-500">Aplicación de Control de Siniestros &copy; 2024</p>
                 <div className="md:hidden mt-2 bg-gray-100 text-gray-600 text-xs px-3 py-1 rounded-full inline-block">{displayUserId}</div>
            </footer>
        </div>
    );
}
